// StatusPage.js - displays scrape status and allows on-demand scraping
import React, { useEffect, useState } from "react";

function StatusPage() {
  const [status, setStatus] = useState("Loading...");
  const [loading, setLoading] = useState(false);
  const [newCount, setNewCount] = useState(null);
  const [lastRun, setLastRun] = useState(null);

  useEffect(() => {
    fetch("/.netlify/functions/scrape-status")
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.message);
        setLastRun(data.lastRun);
        setNewCount(data.newCount);
      });
  }, []);

  const runScraper = async () => {
    setLoading(true);
    setStatus("Running...");
    try {
      const res = await fetch("/.netlify/functions/scrape");
      const data = await res.json();
      setStatus(data.message);
      setNewCount(data.newCount);
      setLastRun(data.lastRun);
    } catch (e) {
      setStatus("Error running scraper");
    }
    setLoading(false);
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-2">Nawa Hub Scraper Status</h1>
      <p>{status}</p>
      {lastRun && <p>Last run: {lastRun}</p>}
      {newCount !== null && <p>New tutorials added: {newCount}</p>}
      <button onClick={runScraper} disabled={loading}>
        {loading ? "Running..." : "Run Scraper Now"}
      </button>
    </div>
  );
}

export default StatusPage;
